import React, {useEffect, useState} from 'react';
import {Button, Col, Table, Row, Icon, notification} from "antd";
import {reportService} from "../../../../services/report.services";
import SelectField from "../../../select-field";
import {distributionCenterService, companyService} from "@services";
import ModalDeliveryInfo from "../../../modals/delivery-info";
import {httpRequest} from "../../../../services/http-request";
import ModalListOrdersDelivery from "../../../modals/list-orders-delivery";
import i18n from "../../../../i18n";
import {carcassTypes, getTranslatedConstant, reportPeriod} from "../../../../helpers/translate.helpers";
import { useConsignorFilter } from '../../../../hooks/use-consignor-filter';
import ConsignorFilterSelect from '../../../consignor-filter-select';

export default function StatsFreeDeliveries() {
  const consignorFilter = useConsignorFilter();
  const { isOwnerUser, consignors, selectedConsignor, setSelectedConsignor, getCompaniesWithConsignor } = consignorFilter;

  const [loading, setLoading] = useState(false);
  const [companiesLoaded, setCompaniesLoaded] = useState(false);
  const [isNeedUpdateReport, setIsNeedUpdateReport] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(true);
  const [errorMsg, setErrorMsg] = useState(null);
  const [expandAll, setExpandAll] = useState(false);

  const [distCenters, setDistCenters] = useState([]);
  const [selectedDistCenters, setSelectedDistCenters] = useState([]);

  const [shipperCompanyID, setShipperCompanyID] = useState([]);
  const [selectedShipperCompanyID, setSelectedShipperCompanyID] = useState([]);

  const [isReturn, setIsReturn] = useState('null');

  const [showModal, setShowModal] = useState(false);
  const [response, getResponse] = useState(0);
  const [deliveryInfo, setDeliveryInfo] = useState(undefined);

  const [showModalOrdersDelivery, setShowModalOrdersDelivery] = useState(false);
  const [responseOrder, getResponseOrder] = useState(0);

  // полученные данные отчета
  const [reportData, setReportData] = useState([]);
  const [summaryData, setSummaryData] = useState([]);

  const colW = (isOwnerUser ? 4 : 5);

  // при первом открытии автоматически запрашиваем данные
  useEffect(() => {
    if (loading === false) {
      setLoading(true);
      setIsNeedUpdateReport(true);

      if (!companiesLoaded) {
        getCompaniesWithConsignor()
          .then((response) => {
            setDistCenters(response);
            setCompaniesLoaded(true);
          }).catch((errorMsg) => {
          setErrorMsg(errorMsg);
          setCompaniesLoaded(true);
        });
      }
      companyService.getShipperCompanyList(selectedConsignor)
        .then((response) => {
          setShipperCompanyID(response);
        }).catch((errorMsg) => {
        setErrorMsg(errorMsg);
      });
    }
  }, [companiesLoaded]);

  // перезагружаем компании при смене consignor
  useEffect(() => {
    if (!companiesLoaded) return;
    setCompaniesLoaded(false);
  }, [selectedConsignor])

  useEffect(() => {
    if (isNeedUpdateReport) {
      let isReturnData = null;
      if (isReturn !== 'null') {
        isReturnData = isReturn;
      }

      // запрос на получение данных отчета
      reportService.getStatsFreeDeliveries(selectedDistCenters, selectedShipperCompanyID, isReturnData, isOwnerUser ? selectedConsignor : null)
        .then((reportData) => {

          const reportFullDataParsed = reportData.fullData.map((item, index) => {
            return {
              id: index + 1,
              title: item.title,
              data: item.data,
              deliveriesCount: item.summary.deliveriesCount,
              assessedVal: item.summary.assessedVal,
              pointsCount: item.summary.pointsCount,
            }
          });

          const summaryDataParsed = reportData.summaryByDistCenter.map((item, index) => {
            return {
              id: item.distributionCenter.id,
              distributionCenter: item.distributionCenter.name,
              deliveriesCount: item.summary.deliveriesCount,
              assessedVal: item.summary.assessedVal,
              pointsCount: item.summary.pointsCount
            }
          })

          setIsNeedUpdateReport(false);
          setLoading(false);
          setReportData(reportFullDataParsed);
          setSummaryData(summaryDataParsed);

        }).catch((errorMsg) => {
          setIsNeedUpdateReport(false);
          setLoading(false);
          setErrorMsg(errorMsg);
        });
    }
  }, [isNeedUpdateReport, companiesLoaded])

  const closeModalHandler = () => {
    setShowModal(false);
    getResponse(0);
    setDeliveryInfo(undefined);
  }

  // получаем данные для модалки "История рейса"
  useEffect(() => {
    if (response !== 0) {
      let url = "delivery/get-delivery-history?deliveryId=" + response;
      httpRequest.get(url).then(function (res) {
        setDeliveryInfo(res.data);
        getResponse(0);
      }).catch((e) => {
        notification.error({
          message: i18n.t('components.notification.titles.historyError'),
          description: e,
        });
        return false;
      })
    }

  }, [response]);

  // отображение фатальной ошибки
  if (errorMsg) {
    return (<div className="content-error-block">{errorMsg}</div>);
  }

  const carcassTypeList = getTranslatedConstant('mode');
  const translatedPeriodTitleList = getTranslatedConstant('reportPeriod');

  // список столбцов таблиц
  const columns = [
    {
      title: '',
      width: 45
    },
    {
      title: '',
      width: 45
    },
    {
      title: i18n.t('reportsPage.statsFreeDeliveries.table.period.title'),
      key: 'title',
      width: 380,
      render: (record) => {
        const period = Object.entries(reportPeriod).filter((item)=>{
          return item[1] === record.title;
        })[0]
        if (period) {
          return translatedPeriodTitleList[period[0]]
        } else {
          return record.title
        }
      }
    },
    {
      title: i18n.t('reportsPage.statsFreeDeliveries.table.deliveriesCount.title'),
      dataIndex: 'deliveriesCount',
      key: 'deliveriesCount',
    },
    {
      title: i18n.t('reportsPage.statsFreeDeliveries.table.assessedVal.title'),
      key: 'assessedVal',
      width: 150,
      render: (record) => (
        <>{record.assessedVal.toLocaleString("ru")}</>
      )
    },
    {
      title: i18n.t('reportsPage.statsFreeDeliveries.table.pointsCount.title'),
      dataIndex: 'pointsCount',
      key: 'pointsCount',
      width: 90
    },
  ];

  const nestedColumns = [
    {
      title: '',
      width: 45
    },
    {
      title: '',
      width: 45
    },
    {
      title: i18n.t('reportsPage.statsFreeDeliveries.table.distributionCenter.title'),
      dataIndex: 'distributionCenter.name',
      key: 'distributionCenter.name',
      width: 380
    },
    {
      title: i18n.t('reportsPage.statsFreeDeliveries.table.deliveriesCount.title'),
      dataIndex: 'summary.deliveriesCount',
      key: 'summary.deliveriesCount',
    },
    {
      title: i18n.t('reportsPage.statsFreeDeliveries.table.assessedVal.title'),
      render: (record) => (
        <>{record.summary.assessedVal.toLocaleString("ru")}</>
      ),
      key: 'summary.assessedVal',
      width: 150,
    },
    {
      title: i18n.t('reportsPage.statsFreeDeliveries.table.pointsCount.title'),
      dataIndex: 'summary.pointsCount',
      key: 'summary.pointsCount',
      width: 90
    },
  ];

  const deliveriesTableColumns = [
    {
      title: '',
      width: 45
    },
    {
      title: '',
      width: 45
    },
    {
      title: <span dangerouslySetInnerHTML={{__html: i18n.t('reportsPage.statsFreeDeliveries.table.number.title')}}/>,
      key: 'number',
      render: (record) => (
        <a className="link link--underline"
           href="#"
           onClick={(e) => {
             e.preventDefault();
             setShowModal(true);
             getResponse(record.id);
           }}
        >{record.number}</a>
      )
    },
    {
      title: <span dangerouslySetInnerHTML={{__html: i18n.t('reportsPage.statsFreeDeliveries.table.dateCreated.title')}}/>,
      dataIndex: 'dateCreated',
      key: 'dateCreated',
    },
    {
      title: <span dangerouslySetInnerHTML={{__html: i18n.t('reportsPage.statsFreeDeliveries.table.carcassType.title')}}/>,
      key: 'carcassType',
      render: (record) => {
        const carcassType = Object.entries(carcassTypes).filter((item)=>{
          return record.carcassType === item[1]
        })[0];
        if (carcassType) {
          return carcassTypeList[carcassType[0]]
        }
        return record.carcassType
      }
    },
    {
      title: <span dangerouslySetInnerHTML={{__html: i18n.t('reportsPage.statsFreeDeliveries.table.hoursInSearch.title')}}/>,
      dataIndex: 'hoursInSearch',
      key: 'hoursInSearch',
      className: "center",
    },
    {
      title: i18n.t('reportsPage.statsFreeDeliveries.table.assessedVal.title'),
      render: (record) => (
        <>{record.assessedVal.toLocaleString("ru")}</>
      ),
      key: 'assessedVal',
    },
    {
      title: <span dangerouslySetInnerHTML={{__html: i18n.t('reportsPage.statsFreeDeliveries.table.pointsCount2.title')}}/>,
      dataIndex: 'pointsCount',
      key: 'pointsCount',
      className: "center",
    },
    {
      title: <span dangerouslySetInnerHTML={{__html: i18n.t('reportsPage.statsFreeDeliveries.table.newOrdersCount.title')}}/>,
      key: 'newOrdersCount',
      render: (record) => {
        return <>
          {(record.newOrdersCount === 0) && ''}
          {(record.newOrdersCount > 0) &&
            <a className="link link--underline"
               style={{marginLeft: '10px'}}
               href="#"
               onClick={(e) => {
                 e.preventDefault();
                 setShowModalOrdersDelivery(true);
                 getResponseOrder(record.id);
               }}
            >{record.newOrdersCount} <Icon type="eye"/></a>
          }
        </>;
      },
    },
  ]

  const summaryTableColumns = [
    {
      title: i18n.t('reportsPage.statsFreeDeliveries.table.distributionCenter.title'),
      dataIndex: 'distributionCenter',
      key: 'distributionCenter',
      width: "min-content"
    },
    {
      title: <span dangerouslySetInnerHTML={{__html: i18n.t('reportsPage.statsFreeDeliveries.table.summaryTable.deliveriesCount')}}/>,
      dataIndex: 'deliveriesCount',
      key: 'deliveriesCount',
    },
    {
      title: <span dangerouslySetInnerHTML={{__html: i18n.t('reportsPage.statsFreeDeliveries.table.summaryTable.assessedVal')}}/>,
      render: (record) => (
        <>{record.assessedVal.toLocaleString("ru")}</>
      ),
      key: 'assessedVal',
    },
    {
      title: <span dangerouslySetInnerHTML={{__html: i18n.t('reportsPage.statsFreeDeliveries.table.summaryTable.pointsCount')}}/>,
      dataIndex: 'pointsCount',
      key: 'pointsCount',
    },
  ]

  return (
    <>
      <div className="reports__header">
        <h1 className="content-header">{i18n.t('reportsPage.statsFreeDeliveries.title')}</h1>
        <Icon type='filter'
              theme={isFilterOpen ? '' : "filled"}
              onClick={() => {
                setIsFilterOpen(!isFilterOpen)
              }}
              className="reports__filter-toggle"/>
        {isFilterOpen && <div className={`reports__filter ${isFilterOpen ? 'is-open' : ""}`}>
          <Row gutter={12} style={{padding: "0", rowGap: "10px"}} type="flex" justify="start">
            {isOwnerUser &&
              <Col lg={colW} md={colW} sm={12} xs={24} style={{paddingRight: "10px"}}>
                <ConsignorFilterSelect
                  isOwnerUser={isOwnerUser}
                  consignors={consignors}
                  selectedConsignor={selectedConsignor}
                  onChange={(value) => {
                    setSelectedConsignor(value);
                    setDistCenters([]);
                    setSelectedDistCenters([]);
                  }}
                />
              </Col>
            }
            <Col lg={colW} md={colW} sm={12} xs={24} style={{paddingRight: "10px"}}>
              <SelectField
                name="distributionCenters"
                selectedValue={selectedShipperCompanyID}
                values={shipperCompanyID}
                onChange={(value) => {
                  setSelectedShipperCompanyID(value);
                }}
                notFoundText={i18n.t('reportsPage.statsFreeDeliveries.filter.shipperCompany.empty')}
                getErrors={() => {
                }}
                style={{width: "100%"}}
                mode={'multiple'}
              />
            </Col>
            <Col lg={colW} md={colW} sm={12} xs={24} style={{paddingRight: "10px"}}>
              <SelectField
                name="distributionCenters"
                selectedValue={selectedDistCenters}
                values={distCenters}
                onChange={(value) => {
                  setSelectedDistCenters(value);
                }}
                notFoundText={i18n.t('reportsPage.statsFreeDeliveries.filter.distributionCenters.empty')}
                getErrors={() => {
                }}
                style={{width: "100%"}}
                mode={'multiple'}
              />
            </Col>
            <Col lg={colW} md={colW} sm={12} xs={24} style={{paddingRight: "10px"}}>
              <SelectField
                  name="isReturn"
                  selectedValue={isReturn}
                  values={[
                    {id: 'null', name: i18n.t('reportsPage.statsFreeDeliveries.filter.isReturn.values.all')},
                    {id: true, name: i18n.t('reportsPage.statsFreeDeliveries.filter.isReturn.values.backOnly')},
                    {id: false, name: i18n.t('reportsPage.statsFreeDeliveries.filter.isReturn.values.withoutBack')},
                  ]}
                  onChange={(value) => {
                    setIsReturn(value);
                  }}
                  notFoundText={i18n.t('main.notFoundText')}
                  getErrors={() => {
                  }}
                  style={{width: "100%"}}
              />
            </Col>
            <Col lg={colW} md={colW} sm={12} xs={24} style={{textAlign: 'right', height: '40px'}}>
              <Button type="primary"
                      htmlType="button"
                      onClick={() => {
                        setLoading(true);
                        setIsNeedUpdateReport(true);
                      }}
                      style={{backgroundColor: '#1CAA53', border: 'none', height: '100%', width: '100%'}}
              >
                {i18n.t('main.buttons.submit')}
              </Button>
            </Col>
          </Row>
        </div>}
      </div>
      <div className="reports__table">
        <div className="reports__table-wrapper">
          <Col span={24}>
            <Table
              style={{width: 'max-content'}}
              columns={columns}
              dataSource={reportData}
              bordered={true}
              locale={{emptyText: i18n.t('main.empty')}}
              rowKey="id"
              size={"small"}
              expandedRowRender={(record) => {
                return <Table
                  columns={nestedColumns}
                  rowKey="key"
                  pagination={false}
                  size={"small"}
                  expandIconAsCell={false}
                  expandIconColumnIndex={1}
                  locale={{emptyText: i18n.t('main.empty')}}
                  bordered={true}
                  footer={() => ''}
                  dataSource={record.data}
                  expandRowByClick={true}
                  expandedRowRender={(record) => {
                    return <Table
                      columns={deliveriesTableColumns}
                      dataSource={record.deliveries}
                      pagination={false}
                      size={"small"}
                      locale={{emptyText: i18n.t('main.empty')}}
                      bordered={true}
                      footer={() => ''}
                      expandRowByClick={true}
                      rowKey="id"
                    />
                  }}
                />
              }}
              expandRowByClick={true}
              defaultExpandAllRows={false}
              expandIconAsCell={false}
              expandIconColumnIndex={0}
              loading={loading}
              pagination={false}
              footer={(currentPageData) => {
                let totalDeliveriesCount = 0;
                let totalAssessedVal = 0;
                let totalPointsCount = 0;
                currentPageData.forEach(({deliveriesCount, assessedVal, pointsCount}) => {
                  totalDeliveriesCount += deliveriesCount;
                  totalAssessedVal += assessedVal;
                  totalPointsCount += pointsCount;
                });
                return <table>
                  <tbody className="ant-table-tbody">
                  <tr className="ant-table-row">
                    <td style={{width: 40}}></td>
                    <td style={{width: 45}}></td>
                    <td className="ant-table-row-cell-break-word" style={{width: 380}}>{i18n.t('reportsPage.statsFreeDeliveries.total')}</td>
                    <td className="">{totalDeliveriesCount}</td>
                    <td className="" style={{width: 150}}>{totalAssessedVal.toLocaleString('ru')}</td>
                    <td className="" style={{width: 90}}>{totalPointsCount}</td>
                  </tr>
                  </tbody>
                </table>;
              }}
            />

          </Col>
          <Col span={24} style={{marginTop: "40px"}}>
            <Table
              style={{width: 'max-content'}}
              columns={summaryTableColumns}
              bordered={true}
              dataSource={summaryData}
              locale={{emptyText: i18n.t('main.empty')}}
              rowKey={"id"}
              loading={loading}
              size="small"
              pagination={false}
              footer={(currentPageData) => {
                let totalDeliveriesCount = 0;
                let totalAssessedVal = 0;
                let totalPointsCount = 0;
                currentPageData.forEach(({deliveriesCount, assessedVal, pointsCount}) => {
                  totalDeliveriesCount += deliveriesCount;
                  totalAssessedVal += assessedVal;
                  totalPointsCount += pointsCount;
                });
                return <table>
                  <tbody className="ant-table-tbody">
                  <tr className="ant-table-row">
                    <td className="ant-table-row-cell-break-word" style={{width: "60%"}}>{i18n.t('reportsPage.statsFreeDeliveries.total')}</td>
                    <td className="">{totalDeliveriesCount}</td>
                    <td className="">{totalAssessedVal.toLocaleString('ru')}</td>
                    <td className="">{totalPointsCount}</td>
                  </tr>
                  </tbody>
                </table>;
              }}
            />

          </Col>
        </div>
      </div>
      {deliveryInfo && <ModalDeliveryInfo
        deliveryInfo={deliveryInfo}
        isShow={showModal}
        setIsShow={closeModalHandler}
      />}
      {<ModalListOrdersDelivery
        isShow={showModalOrdersDelivery}
        setIsShow={setShowModalOrdersDelivery}
        deliveryId={responseOrder}
      />}
    </>
  );
}
